import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-traders-forgot-password',
  templateUrl: './traders-forgot-password.component.html',
  styleUrls: ['../style/global.css', './traders-forgot-password.component.css'],
})
export class TradersForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
